import { track } from '@helsenorge/framework-utils/amplitude';
import { BenyttetHjelp } from '@helsenorge/framework-utils/amplitude/ampli';
/**
 * Spor bruk av prosesshjelp i Amplitude.
 *
 * @param componentName Navn på hjelpekomponent
 * @param text Hjelpetekst som er klikket på
 */
export const trackProsesshjelp = (componentName, text) => {
    track(new BenyttetHjelp({
        handling: 'få hjelp',
        objekt: componentName,
        hjelpTekst: text,
    }));
};
